export default "__VITE_ASSET__DM9z_yi___"